import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IntlService } from '../../core/services/intl.service';

@Component({
  selector: 'app-cookies-policy',
  templateUrl: './cookies-policy.component.html',
  styleUrls: ['./cookies-policy.component.scss']
})
export class CookiesPolicyComponent implements OnInit {

  @ViewChild('ngxCookiebot', {static: true})
  ngxCookiebotElement: ElementRef;

  constructor(@Inject(DOCUMENT) private document, private intlService: IntlService, @Inject(PLATFORM_ID) protected platformId) { }

  ngOnInit() {
    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'CookieDeclaration';
    script.src = 'https://consent.cookiebot.com/' + environment.cookieBot.cbId + '/cd.js';
    script.async = true;

    script.setAttribute("data-culture", this.intlService.getCurrentLanguage()?.toLocaleUpperCase());

    if (isPlatformBrowser(this.platformId)) {
      this.ngxCookiebotElement?.nativeElement?.append(script);
    }
  }

}
